import styled from "styled-components";

export default styled.div`
    color: #000;
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;

    & > svg {
        color: #0000000a;
        height: 160%;
        left: -24px;
        pointer-events: none;
        position: absolute;
        top: -30%;
        width: auto;
    }

    & > div {
        align-items: center;
        display: flex;
        flex: none;
        flex-direction: row;

        input {
            background: transparent;
            border: none;
            box-sizing: border-box;
            font-family: var(--font-mono), monospace;
            font-size: 3.2rem;
            flex: auto;
            margin: 0;
            outline: none;
            padding: 0;
        }

        button[type="reset"] {
            align-items: center;
            background: transparent;
            border: none;
            color: #0007;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            font-size: 2rem;
            padding: 0;
            transition: 200ms;

            &:hover {
                color: #000;
            }
        }
    }

    & > span {
        cursor: default;
        font-family: var(--font-mono), monospace;
        font-size: .7rem;
        opacity: .6;
        padding: 0 2px;
        white-space: nowrap;

        i {
            background: #cccc;
            border-radius: 4px;
            padding: 2px 4px;
        }
    }
`;
